module.exports = __webpack_public_path__ + "media/images/partners/mtn-b745c7c5ca9e5be803238693407f64be.png";